import { render, staticRenderFns } from "./wtGridImagesGallery.component.vue?vue&type=template&id=351daa9e&"
import script from "./wtGridImagesGallery.component.vue?vue&type=script&lang=js&"
export * from "./wtGridImagesGallery.component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports